import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var AlertOutline = function AlertOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 22.0674H20.25C22.1299 22.0674 23.333 20.6816 23.333 18.9736C23.333 18.458 23.2041 17.9316 22.9248 17.4482L14.6533 3.03223C14.0732 2.00098 13.042 1.47461 12 1.47461C10.958 1.47461 9.91602 2.01172 9.33594 3.03223L1.06445 17.459C0.785156 17.9424 0.65625 18.458 0.65625 18.9736C0.65625 20.6816 1.87012 22.0674 3.75 22.0674ZM3.9541 20.0049C3.28809 20.0049 2.84766 19.457 2.84766 18.8662C2.84766 18.6943 2.86914 18.4795 2.97656 18.2861L11.0332 4.18164C11.248 3.81641 11.624 3.64453 12 3.64453C12.376 3.64453 12.7412 3.81641 12.9453 4.18164L21.0127 18.3076C21.1094 18.4902 21.1523 18.6943 21.1523 18.8662C21.1523 19.457 20.7012 20.0049 20.0352 20.0049H3.9541ZM12 14.6123C12.5908 14.6123 12.9346 14.2793 12.9453 13.6562L13.1064 8.48926C13.1279 7.85547 12.6553 7.4043 11.9893 7.4043C11.3232 7.4043 10.8613 7.84473 10.8828 8.47852L11.0332 13.667C11.0547 14.2793 11.3984 14.6123 12 14.6123ZM12 18.1787C12.6982 18.1787 13.2676 17.6738 13.2676 16.9971C13.2676 16.3096 12.709 15.8154 12 15.8154C11.3018 15.8154 10.7324 16.3203 10.7324 16.9971C10.7324 17.6738 11.3125 18.1787 12 18.1787Z"
  })));
};

AlertOutline.displayName = 'AlertOutline';
export default AlertOutline;